import React from "react"

const Underline = () => {
  return (
    <>
      <div className="bg-green-500 h-1 w-20 mx-auto"></div>
    </>
  )
}

export default Underline
